import gql from 'graphql-tag'

const queryTarifs = gql`query bookedTariff {
  tariffs{
    bookedTariff {
      tariffId
      tariffState
      name
      basicFee
      formattedBasicFee
      terminationDate
      renewContractDate
      contractPeriod
      changeTariffDate
      volumes {
        formattedUnit
        type
        amount
        unit
      }
    }
  }
  tariffoptions{
    bookedTariffoptions {
      bookedTariffoptions {
        automaticExtension
        tariffoptionId
        name
        details
        price
        formattedPrice
        statusKey
        activeRuntime {
          endOfRuntime
          startOfRuntime
        }
        duration {
          amount
          unit
          formattedUnit
        }
        volumes {
          formattedUnit
          type
          amount
          unit
        }
      }
    }
  }
}`

export default queryTarifs
